(function() { window.GUID_e13ee655_49bc_4be5_85c6_9d76246fe77c = { getGuid: function() { return "e13ee655-49bc-4be5-85c6-9d76246fe77c"; } }; })();
var GeneralSearch;
(function (GeneralSearch) {
    var pubsRotator;
    var searchInputs;
    var selectedEntityIdAutoComplete;
    GeneralSearch.treeViewDivisions = null;
    function BindElements() {
        GeneralSearch.callFromHomePage = $('#CallFromHomePage').val();
        pubsRotator = $('#PubsRotator');
        GeneralSearch.iFrameHomePageContainer = $('#IFrameHomePageContainer');
        GeneralSearch.searchResult = $('#SearchResult');
        searchInputs = $('#SearchInputs');
        selectedEntityIdAutoComplete = $('#SelectedEntityIdAutoComplete');
        GeneralSearch.shareFacebookEvent = $('#ShareFacebookEvent');
    }
    GeneralSearch.BindElements = BindElements;
    var blockWhileClear = false;
    function SelectedEntity(entityId, divisionId, extMatchId) {
        if (blockWhileClear) {
            return;
        }
        if (selectedEntityIdAutoComplete != null && selectedEntityIdAutoComplete.length > 0) {
            selectedEntityIdAutoComplete.blur();
        }
        /*Pour eviter de voir le bouton shared en double, ca enleve celui de la toolbar*/
        if (GeneralSearch.shareFacebookEvent.length > 0) {
            GeneralSearch.shareFacebookEvent.hide();
        }
        var data = {};
        data.entityId = entityId;
        data.divisionId = divisionId;
        data.extMatchId = IsDefined(typeof (extMatchId)) ? extMatchId : null;
        blockWhileClear = true;
        if (document.SelectedEntityId != null) {
            document.SelectedEntityId.ClearValue();
        }
        if (divisionId == null && GeneralSearch.treeViewDivisions != null && GeneralSearch.treeViewDivisions.SelectedValue() != null) {
            GeneralSearch.treeViewDivisions.ClearSelection();
        }
        blockWhileClear = false;
        if ((entityId === null || entityId === "") && (divisionId === null || divisionId === "-1") && (data.extMatchId === null)) {
            GeneralSearch.searchResult.slideUp(250);
        }
        else {
            if (data.entityId != null) {
                SetCookieValue(CSParameters.SportEventId, "SelectedEntityId", data.entityId);
            }
            if (data.divisionId != null) {
                SetCookieValue(CSParameters.SportEventId, "SelectedDivisionId", data.divisionId);
            }
            GeneralSearch.searchResult.slideUp(250, function () {
                CompuSport.Ajax.Get(CSParameters.RUrl + "GeneralSearch/SearchResultAsyncro/" + CSParameters.SportEventId, data, function (queryResult) {
                    pubsRotator.hide();
                    GeneralSearch.iFrameHomePageContainer.hide();
                    GeneralSearch.searchResult.html(queryResult);
                    BindSearchResultsEvents(GeneralSearch.searchResult);
                    GeneralSearch.searchResult.scrollTop(0);
                    GeneralSearch.searchResult.slideDown(250, 'swing', function () {
                        if (GeneralSearch.Desktop != undefined && GeneralSearch.Desktop.SetTimer != undefined) {
                            GeneralSearch.Desktop.waitingForTimeOut = true;
                            GeneralSearch.Desktop.SetTimer();
                        }
                    });
                });
            });
        }
    }
    GeneralSearch.SelectedEntity = SelectedEntity;
    function TriggerClickInsideNewsfeedIframe(idOfButtonInsideIframe) {
        //var iframe = document.getElementById('IFrameHomePage');
        //var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        var $iFrameDOM = $("iframe#IFrameHomePage").contents();
        $iFrameDOM.find(`button#${idOfButtonInsideIframe}`).trigger("click");
    }
    GeneralSearch.TriggerClickInsideNewsfeedIframe = TriggerClickInsideNewsfeedIframe;
    CS.body.on('scoresheetupdated.chart', function (e, response) {
        SelectedEntity($('#EntityBaseId').val(), null);
    });
    function OnTreeViewItemSelected(treeViewItem) {
        if (treeViewItem == null || treeViewItem.data('id') == "") {
            SelectedEntity(null, null, null);
            return;
        }
        SelectedEntity(null, treeViewItem.data('id'), null);
        GeneralSearch.treeViewDivisions.SelectTreeViewItemByData('id', '');
    }
    GeneralSearch.OnTreeViewItemSelected = OnTreeViewItemSelected;
    function BindSearchResultsEvents(searchResult) {
        if (GeneralSearch.callFromHomePage == "True") {
            $('#ShareFacebook').show();
        }
        GeneralSearch.shareFacebookEvent.off('click');
        GeneralSearch.shareFacebookEvent.on('click', function () {
            var url = window.location.protocol + '//' + window.location.host + '/' + CSParameters.SportEventId;
            CS.LogAction('/' + CSParameters.SportEventId, 'ShareFacebookEvent');
            FB.ui({
                method: 'share',
                href: url
            }, function (response) { });
        });
        $('#ShareFacebook').off('click');
        $('#ShareFacebook').on('click', function () {
            var url = "";
            var description = "";
            /*remettre au default*/
            if ($('#EntityBaseId').length > 0) {
                var entityBaseId = $('#EntityBaseId', searchResult).val();
                var entityName = $('#EntityBaseName', searchResult).val();
                var opponentPath = '/opponent/' + CSParameters.SportEventId + '/' + entityBaseId + '/';
                url = window.location.protocol + '//' + window.location.host + opponentPath;
                //url = window.location.protocol + '//' + window.location.host + '/opponent/' + CSParameters.SportEventId + '/' + entityBaseId;
                description = JSRess.FacebookShare + " " + entityName;
                CS.LogAction(opponentPath, 'ShareFacebookEntity');
                let data = {
                    entityBaseId: entityBaseId,
                    sportEventId: CSParameters.SportEventId
                };
                CompuSport.Ajax.Get(CSParameters.RUrl + "PhotoBooth/ForceScrapeFacebookWithoutRedirect/" + CSParameters.SportEventId, data, function (response) {
                    let urlFetch = response.url;
                    ShareFacebook(urlFetch, description);
                });
                return;
            }
            else {
                var divisionId = $('#DivisionId', searchResult).val();
                var divisionName = $('#DivisionName', searchResult).val();
                var divisionPath = '/division/' + CSParameters.SportEventId + '/' + divisionId;
                url = window.location.protocol + '//' + window.location.host + divisionPath;
                description = JSRess.FacebookShareDivision + " " + divisionName;
                CS.LogAction(divisionPath, 'ShareFacebookDivision');
                ShareFacebook(url, description);
            }
        });
        $('.FlowBlockItem', searchResult).off('click');
        $('.FlowBlockItem', searchResult).on('click', function () {
            var $this = $(this);
            var flowBlockId = this.id;
            var isBracket = $this.data('isbracket');
            var entityBaseId = $this.data('entitybaseid');
            var extMatchId = $this.data('extmatchid');
            LoadChart(flowBlockId, isBracket, entityBaseId, extMatchId);
        });
        $('.ScheduleItem', searchResult).off('click');
        $('.ScheduleItem', searchResult).on('click', function (e) {
            if ($(e.target).hasClass('SetWinner')) {
                return;
            }
            var $this = $(this);
            var flowBlockId = $this.data('fbid');
            var isBracket = $this.data('isbracket');
            var entityBaseId = $this.data('entitybaseid');
            var extMatchId = $this.data('extmatchid');
            LoadChart(flowBlockId, isBracket, entityBaseId, extMatchId);
        });
        var lastGeneralSearchTeamRoster = null;
        $('.AwardItem', searchResult).off('click');
        $('.AwardItem', searchResult).on('click', function () {
            var $this = $(this);
            var awardDividion = $('#AwardDivisionId');
            var data = {
                entityBaseId: $this.data('entityid'),
                awardDividionId: awardDividion.length > 0 ? awardDividion.val() : null
            };
            CompuSport.Ajax.Get(CSParameters.RUrl + "GeneralSearch/GetTeamRoster/" + CSParameters.SportEventId, data, function (response) {
                if (lastGeneralSearchTeamRoster != null) {
                    lastGeneralSearchTeamRoster.slideUp();
                }
                var $response = $(response);
                lastGeneralSearchTeamRoster = $response;
                $response.insertAfter($this);
                $response.slideDown();
            });
        });
    }
    GeneralSearch.BindSearchResultsEvents = BindSearchResultsEvents;
    function LoadChart(flowBlockId, isBracket, entityBaseId, extMatchId) {
        //if (GeneralSearch.Mobile != undefined && GeneralSearch.Mobile.LoadChartMobile != undefined) {
        //    GeneralSearch.Mobile.LoadChartMobile(flowBlockId, isBracket, entityBaseId);
        //} else {
        GeneralSearch.Desktop.LoadChartDesktop(flowBlockId, isBracket, entityBaseId, extMatchId);
        //}
    }
    function ShareFacebook(url, description) {
        FB.ui({
            method: 'share',
            href: url
        }, function (response) { });
    }
})(GeneralSearch || (GeneralSearch = {}));

//# sourceMappingURL=GeneralSearch.js.map
